import Immutable from "immutable";

const BasketItemIssue = new Immutable.Record({
  itemType: undefined,
  basketItemID: undefined,
  studentID: undefined,
  reason: undefined
}, "Basket Item Issue");

function buildBaksetItemIssueFromBasketItem({ basketItemID, studentID, type }, reason) {
  return BasketItemIssue({
    basketItemID,
    studentID,
    itemType: type,
    reason
  });
}

BasketItemIssue.fromBasketItem = buildBaksetItemIssueFromBasketItem;
export default BasketItemIssue;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/BasketItemIssue.js